import { cn, tv } from '@pcln/horizon'

// Car form variant definitions
const carFormVariants = {
  differentDropOff: {
    gridContainer:
      'grid-cols-[auto_auto] sm:grid-cols-[auto_auto_auto_auto] lg:grid-cols-[minmax(0,0.4fr)_minmax(0,0.4fr)_auto_auto_auto_auto_max-content]'
  },
  sameDropOff: {
    gridContainer:
      'grid-cols-[auto_auto] sm:grid-cols-[auto_auto_auto_auto] lg:grid-cols-[minmax(0,0.8fr)_auto_auto_auto_auto_max-content]'
  },
  hotelOnly: {
    gridContainer:
      'grid-cols-2 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_max-content]'
  },
  withFlight: {
    gridContainer:
      'grid-cols-2 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_auto_minmax(0,0.8fr)_max-content]'
  }
} as const

type CarTypeVariant = keyof typeof carFormVariants

const carFormSlots = {
  gridContainer: 'grid grid-cols-1 gap-3 items-center mx-auto',
  optionsWrapper: 'col-span-full',
  pickupInput: 'col-span-full lg:[grid-area:unset]',
  dualPickupInput: 'col-span-2 lg:[grid-area:unset]',
  dropoffInput: 'col-span-2 lg:[grid-area:unset]',
  packageInput:
    'flex flex-row items-center justify-start gap-4 text-sm sm:col-span-2 col-span-full lg:order-1',
  submitInput: 'col-span-2 lg:[grid-area:unset]'
} as const

export const horizonCarForm = tv({
  slots: carFormSlots,
  variants: { carType: carFormVariants },
  defaultVariants: { carType: 'sameDropOff' }
})

// Utility functions
export const getGridContainerClass = (
  isDifferentDropOff = false,
  isHotel = false,
  isFlight = false
) => {
  let variant: CarTypeVariant

  switch (true) {
    case isFlight:
      variant = 'withFlight'
      break
    case isHotel:
      variant = 'hotelOnly'
      break
    case isDifferentDropOff:
      variant = 'differentDropOff'
      break
    default:
      variant = 'sameDropOff'
  }

  const styles = horizonCarForm({ carType: variant })
  return cn(styles.gridContainer())
}

export const getInputClass = (
  type: 'options' | 'pickup' | 'dropoff' | 'package' | 'submit',
  isDifferentDropOff = false
) => {
  const styles = horizonCarForm()
  switch (type) {
    case 'pickup':
      return isDifferentDropOff
        ? styles.dualPickupInput()
        : styles.pickupInput()
    case 'options':
      return styles.optionsWrapper()
    case 'dropoff':
      return styles.dropoffInput()
    case 'package':
      return styles.packageInput()
    case 'submit':
      return styles.submitInput()
    default:
      return ''
  }
}
